import clsx from 'classnames';

import { FieldHintProps } from './types';
import styles from './FieldHint.module.scss';

export function FieldHint({ children, isError }: FieldHintProps) {
	return (
		<div
			className={clsx(`FieldHint`, styles.FieldHint__wrapper, {
				[styles['FieldHint__wrapper--isError']]: !!isError,
			})}
		>
			{children}
		</div>
	);
}
